import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateTrainingIssue = createAsyncThunk(
  "AgentTrainingIssues/updateTrainingIssue",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/trainingIssues/${data.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response,"error")
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

